window.OnCreditCardReady = function () {

    $('#payNow').click(function () {
        $(this).prop('disabled', true);
        SubmitForm();
    });

    if ($("#notEndUser").val() == "True" && $("#isSapSystemUSA").val() == "True") {

        $('#totalComputed').text($('#totalWsPrice').text())
        $('#transactionAmount').val($('#totalWsPrice').text())
    }
    else {
        $('#totalComputed').text($('#totalRtPrice').text())
        $('#transactionAmount').val($('#totalRtPrice').text())
    }

    _notificationMessage = $("#notificationMessage").html();
    _notificationType = $("#notificationType").html();

    if (_notificationType == "SUCCESS") {

        $('.diContainerBorder').hide();
        $('#processingAlert').show();
        $('#payNow').hide();

        $.ajax({
            type: 'POST',
            url: '/en-US/Repair/Approve',
            data: $("#form0").serialize(),
            statusCode: {
                200: function (data) {
                    $('#processingAlert').hide();
                    Notification(data["NotificationType"], data["NotificationMessage"]);
                    $('html').animate({ scrollTop: 0 }, 'fast');
                },
                401: function () {
                    window.location.href = $("loginUrl").val();
                }
            }
        })

    }

    if (_notificationType == "ERROR") {

        Notification(_notificationType, _notificationMessage);
    }

    /***********************************************
    ByWire modal
    ************************************************/

    $.fn.ConfirmModal().Close = function () {
        this.modal('hide');
    }
    $.fn.ConfirmModal().Open = function () {
        this.modal('show');
    }
}



